import type { FetchResult } from "./opsPaperworkClientBase";
import { opsFetch } from "./opsPaperworkClientBase";
import type { ManufacturerPayableCategory, ManufacturerPayableStatus } from "@/lib/ops/manufacturerPayablesMath";

const BASE = "/api/ops/manufacturer-payables";

export type ManufacturerPayable = {
  id: string;
  organization_id: string;
  deal_id: string | null;
  manufacturer: string;
  category: ManufacturerPayableCategory;
  collected_usd: number;
  allowed_deposit_usd: number;
  amount_owed_usd: number;
  amount_paid_usd: number;
  status: ManufacturerPayableStatus;
  paid_at: string | null;
  paid_reference: string;
  notes: string;
  created_at: string;
  updated_at: string;
  deal_display_name: string | null;
};

export type ManufacturerPayableTotals = {
  remaining_usd: number;
  owed_usd: number;
  by_manufacturer: Array<{ manufacturer: string; remaining_usd: number; count: number }>;
  by_category: Array<{ category: string; remaining_usd: number; count: number }>;
};

export function listOpsManufacturerPayables(filters: { status?: string; deal_id?: string } = {}) {
  const q = new URLSearchParams();
  if (filters.status) q.set("status", filters.status);
  if (filters.deal_id) q.set("deal_id", filters.deal_id);
  const suffix = q.toString() ? `?${q.toString()}` : "";
  return opsFetch<{ ok: true; payables: ManufacturerPayable[]; totals: ManufacturerPayableTotals }>(
    `${BASE}${suffix}`,
    { method: "GET" }
  );
}

export function createOpsManufacturerPayable(payload: {
  manufacturer: string;
  category: ManufacturerPayableCategory;
  collected_usd: number;
  allowed_deposit_usd: number;
  deal_id?: string | null;
  notes?: string;
}) {
  return opsFetch<{ ok: true; payable: ManufacturerPayable }>(BASE, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function patchOpsManufacturerPayable(payload: {
  id: string;
  status?: ManufacturerPayableStatus;
  collected_usd?: number;
  allowed_deposit_usd?: number;
  amount_paid_usd?: number;
  payment_usd?: number;
  paid_reference?: string;
  notes?: string;
  manufacturer?: string;
  category?: ManufacturerPayableCategory;
}) {
  return opsFetch<{ ok: true; payable: ManufacturerPayable }>(BASE, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export type { FetchResult };
